import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Node } from '@uncinc/react-drupal-core';
import i18next from '../../../config/i18next';
import { DEFAULT_FADE_DURATION_MS } from '../../../config/constants';

import {
  Container,
  Button,
  Loader,
} from '../../../components';

const NewsAll = ({ onLoadMore, pager, loading, entities, ...props }) => {
  const totalPages = pager.get('total_pages');
  const currentPage = pager.get('current_page');
  return (
    <div className="View NewsSelection">
      <Container>
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'col-12 col-lg-4';
            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                </Fade>
              </div>
            );
          })}
        </div>
      </Container>
      { currentPage < totalPages && (
        <div className="ViewAwards__button">
          <Button secondary withIcon buttonIconVertical href="#" onClick={(e) => { e.preventDefault(); onLoadMore(); }}>{ i18next.t('view_load_more') }</Button>
        </div>
      )}
      <Loader loading={loading} />
    </div>
  );
};

export default NewsAll;
